import './styles/reset.scss';
import './styles/icons.scss';
import './styles/header.scss';
import './styles/global.scss';
import './styles/404.scss';
import './styles/single_building.scss';
import './styles/single_article.scss';
import './styles/category.scss';
import './styles/footer.scss';
import './styles/select-only.scss';


import './scripts/scripts';
import './scripts/single_building';
import './scripts/single_article';

import '../inc/shortcodes/find-an-apartment/find-an-apartment.js';

import '../template-parts/blocks/home-banner/script.js';
import '../template-parts/blocks/home-neighborhoods/script.js';
import '../template-parts/blocks/home-about-us/script.js';
import '../template-parts/blocks/home-featured-properties/script.js';
import '../template-parts/blocks/list-of-properties/script.js';
import '../template-parts/blocks/about-neighborhood/script.js';
import '../template-parts/blocks/map-and-location/script.js';
import '../template-parts/blocks/transportation/script.js';
import '../template-parts/blocks/neighborhood-banner/script.js';
import '../template-parts/blocks/parks_recreation/script.js';
import '../template-parts/blocks/schools/script.js';
import '../template-parts/blocks/neighborhoods-buildings/script.js';
import '../template-parts/blocks/dining-entertainment/script.js';
import '../template-parts/blocks/team-group/script.js';
import '../template-parts/blocks/about-our-team/script.js';
import '../template-parts/blocks/community-commitment/script.js';
import '../template-parts/blocks/careers/script.js';
import '../template-parts/blocks/engineers-list/script.js';
import '../template-parts/blocks/post-featured-properties/script.js';
import '../template-parts/blocks/related-articles/script.js';
import '../template-parts/blocks/blog-posts/script.js';
import '../template-parts/blocks/faq/script.js';
import '../template-parts/blocks/online-applications/script.js';